var map = {
	"./black/guaduan2.png": "vsUr",
	"./blue/guaduan2.png": "YXrJ",
	"./white/guaduan2.png": "Gu8d"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GghT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/guaduan2\.png$
// module id = GghT
// module chunks = 24